module.exports = __webpack_public_path__ + "static/media/img17.64d07043.jpg";